import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import { clearSailingDataError, fetchSailingDataAction } from '@/actions/voyagePlanner/summary/sailingData';
import { selectIsNeedFetchCelebrationSailing } from '@/ducks/programs/celebrations/selectors';
import { backToMainPage } from '@/ducks/voyageInfo/category/navigation';
import {
  selectBestPriceSailingByPackageCode,
  selectHasSailingDataFetchError,
  selectIsSailingDataEmpty,
  selectIsSailingDataLoaded,
} from '@/ducks/voyageInfo/sailing/selectors';
import { setEmptySailingDataWarningExhausted } from '@/features/warnings/actions';
import { useAppDispatch, useAppSelector } from '@/store';

export const useFetchSailingData = () => {
  const dispatch = useAppDispatch();
  const searchParams = useSearchParams();
  const packageCode = searchParams?.get('packageCode');
  const voyageId = searchParams?.get('voyageId');
  const isLoaded = useAppSelector((state) => selectIsSailingDataLoaded(state, searchParams!));
  const isEmpty = useAppSelector(selectIsSailingDataEmpty);
  const fetchError = useAppSelector(selectHasSailingDataFetchError);
  const defaultVoyageId = useAppSelector((state) => selectBestPriceSailingByPackageCode(state, packageCode))?.id;
  const anyVoyageId = voyageId || defaultVoyageId;

  const isNeedFetchCelebrationSailing = useAppSelector(selectIsNeedFetchCelebrationSailing);

  useEffect(() => {
    if (!isLoaded && packageCode) {
      dispatch(fetchSailingDataAction({ packageCode, voyageId: anyVoyageId }));
    }
  }, [searchParams]);

  useEffect(() => {
    if (isNeedFetchCelebrationSailing) {
      dispatch(fetchSailingDataAction({ packageCode, voyageId: anyVoyageId }));
    }
  }, [isNeedFetchCelebrationSailing, anyVoyageId, packageCode]);

  useEffect(() => {
    if (fetchError || (isLoaded && isEmpty) || !anyVoyageId) {
      dispatch(setEmptySailingDataWarningExhausted());
      dispatch(clearSailingDataError());
      backToMainPage();
    }
  }, [dispatch, fetchError, isLoaded, isEmpty, anyVoyageId]);
};
